import Scrollbars from 'react-custom-scrollbars-2';
import { PatientProfileHeader } from './header/header';
import { usePatientProfilePage } from './hooks';
import { Inbox } from './inbox';
import { Navbar } from './navigation/navbar/navbar';
import { PatientProfilePageRouter } from './navigation/router';
import { PatientProfilePageSkeleton } from './patient-profile-page.skeleton';
import { Content, PatientProfilePageWrapper } from './patient-profile-page.styles';

export const PatientProfilePageComponent = () => {
  const { isLoading } = usePatientProfilePage();

  if (isLoading)
    return (
      <PatientProfilePageWrapper>
        <PatientProfilePageSkeleton />
      </PatientProfilePageWrapper>
    );

  return (
    <PatientProfilePageWrapper>
      <Scrollbars autoHide>
        <Content>
          <PatientProfileHeader />
          <Navbar />
          <PatientProfilePageRouter />
        </Content>
      </Scrollbars>
      <Inbox />
    </PatientProfilePageWrapper>
  );
};
